<template>
    <span>
        <q-btn flat no-caps v-for="(btn, index) in size_template" :key="index" @click="setTemplateSize(index)">{{btn.title}}</q-btn>
    </span>    
</template>

<script>
/* eslint-disable */
export default {
    data () {
        return {
            size_template : [
                {title :'6 x 3', width:6, height:3},
                {title :'1,2 x 1,8', width:1.2, height:1.8},
                {title :'6,08 x 3,02', width:6.08, height:3.02},
            ],

        }
    },

    methods : {
        setTemplateSize(index) {
          this.$emit('defaultSize', this.size_template[index]); // передаем событие только родителю!
        }
    },

}
</script>

